import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { merge, throwError as _throw, } from 'rxjs';
import { switchMap, filter } from 'rxjs/operators';

import { DlgWelcomeComponent } from '../core/dlg-welcome.component';

@Injectable()
export class ShowDlgWorldWelcomeService {
    constructor(
        private _dialog: MatDialog,
    ) {
    }

    show(): Promise<any> {
        const dialogRef = this._dialog.open(DlgWelcomeComponent, {
            backdropClass: '--ui-backdrop',
            panelClass: ['--ui', '--transparent']
        });

        const source = dialogRef.afterClosed();
        const success$ = source
            .pipe(filter<boolean>((val) => val));
        const error$ = source
            .pipe(filter((val) => !val))
            .pipe(switchMap((error) => _throw(`${ error }`)));

        return merge(success$, error$).toPromise();
    }
}
